import { writable } from 'svelte/store';
import { idb } from '../db';

const DB_TABLE = `pc_recurring`;

const initRecurring = () => {
    const { subscribe, set, update } = writable();

    const helpers = {
        init: async ( key, index ) => {
            // Default to get all lists if no index is set
            if( ! key ) {
                set(await idb.getAll( DB_TABLE ))
            // If just a key is provided return the record uid matches the key
            } else if ( ! index ){
                set([await idb.get( DB_TABLE, key)]);
            // If an index is also provide return the list of records where the index matches the key
            } else {
                set(await idb.getAllFromIndex.eq( DB_TABLE, index, key));
            }
        },
        add: ( data ) => { 
            console.group(`INFO: recurring.add`);console.log(`data added`);console.log(data);
            update( state => {
                if ( ! state ) state = [];
                const newState = state.concat(data);
                console.log(`New state`);console.log(newState);

                idb.save( 'pc_recurring', newState);
                return newState; 
            })
            
            console.groupEnd();
        },
        editSingleField: async ( uid, field, data ) => { update( current => {
            console.group(`INFO: recurring.editSingleField`);console.log(uid, field, data);console.groupEnd();
            const index = current.findIndex( item => item.uid == uid);
            console.group(`INFO: recurring.editSingleField`);console.log(index, current[index]);console.groupEnd();
            if(current[index]){
                current[index][field] = data;
                current[index].lastUpdated = Date.now();
                console.group(`INFO: recurring.editSingleField`);console.log([...current]);console.groupEnd();
                idb.save(`pc_recurring`, [current[index]])
                return [ ...current ]
            }else{
                return current;
            }
            
        })},
        edit: ( uid, data ) => { update( state => state[state.findIndex( state => state.uid == uid)] = data ) },
        delete: async ( uid ) => { 
            update( current => current.filter( entry => entry.uid != uid) );
            idb.delete('pc_recurring', uid );
        }
    }
    return {
        subscribe,
        set,
        update,
        ...helpers
    }
};
export const recurring = initRecurring()